import { AuthView } from '../types';

interface AuthFormLinksProps {
	view: AuthView;
}

export const AuthFormLinks = ({ view }: AuthFormLinksProps) => {
	return (
		<div className="text-sm text-center mt-2">
			{view === 'sign_in' && (
				<div className="flex flex-col sm:flex-row justify-center gap-2 sm:gap-4 items-center">
					<a
						href="/auth?view=forgot_password"
						className="text-blue-400 hover:text-blue-300 transition-colors"
					>
						Forgot password?
					</a>
					<span className="hidden sm:inline text-gray-500">•</span>
					<a
						href="/auth?view=sign_up"
						className="text-emerald-400 hover:text-emerald-300 transition-colors font-medium"
					>
						New here? <span className="underline">Start free trial</span>
					</a>
				</div>
			)}
			{view === 'sign_up' && (
				<a href="/auth?view=sign_in" className="text-blue-400 hover:text-blue-300 transition-colors font-medium">
					Already have an account? <span className="underline">Sign in</span>
				</a>
			)}
			{(view === 'forgot_password' ||
				view === 'reset_password' ||
				view === 'confirm_reset_password') && (
				<a href="/auth?view=sign_in" className="text-blue-400 hover:text-blue-300 transition-colors font-medium">
					<span className="underline">Back to sign in</span>
				</a>
			)}
		</div>
	);
};
